import date from 'date-and-time'

const orderDayOffset = 3

const minimumNumberOfWeeks = 2

const attributes = {
  highlight: {
    start: {
      style: {
        backgroundColor: '#000', // blue
      },
      contentStyle: {
        color: '#ffffff', // color of the text
      },
    },
    base: {
      style: {
        backgroundColor: '#000', // light blue
      },
    },
    end: {
      style: {
        backgroundColor: '#000', // blue
      },
      contentStyle: {
        color: '#ffffff', // color of the text
      },
    },
  },
}

let startDate = date.addDays(new Date(), orderDayOffset)
const dayOfWeek = startDate.getDay()
if (dayOfWeek === 0 || dayOfWeek === 6) {
  // we dont want to have weekends as start day
  startDate = date.addDays(startDate, (dayOfWeek % 5) + 1) // lets make sure that we start from monday
}

const disabledDates = [{ weekdays: [1, 7] }, { end: date.addDays(new Date(), orderDayOffset - 1) }]

export { startDate, disabledDates, attributes, minimumNumberOfWeeks }
